import { useMemo } from "react";
import { useSelector } from "react-redux";

import Flx from "../../../../components/layout/Flx";
import ScreenContent from "../../../../components/layout/ScreenContent";
import TabPanel from "../../../../components/navigation/TabPanel";

import LoanDrilldownChangesForm from "../../../../forms/LoanDrilldownChangesForm";
import SummaryLoanRelatedContactsCard from "./cards/SummaryLoanRelatedContactsCard";
import SummaryTabBorrowersCard from "./cards/SummaryTabBorrowersCard";
import SummaryTabCommentsCard from "./cards/SummaryTabCommentsCard";
import SummaryTabLoanAssigneesCard from "./cards/SummaryTabLoanAssigneesCard";
import SummaryTabLoanFilesCard from "./cards/SummaryTabLoanFilesCard";
import SummaryTabLoanInformationCard from "./cards/SummaryTabLoanInformationCard";
import SummaryTabLoanTotalsCard from "./cards/SummaryTabLoanTotalsCard";
import SummaryTabPropertiesCard from "./cards/SummaryTabPropertiesCard";
import SummaryTabSummaryCard from "./cards/SummaryTabSummaryCard";

// Lazy load heavy components

const LoanDrilldownSummaryTab = () => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const baseUrl = useMemo(
    () => `/loan/${loanDrilldown?.loanNumber}`,
    [loanDrilldown],
  );

  return (
    <TabPanel>
      <ScreenContent
        sx={{
          maxWidth: "1800px",
          p: 3,
          pb: 24,
          margin: "0px auto",
          h5: {
            fontSize: "13px",
            fontWeight: 600,
            // fontSize: "14px",
            // fontWeight: 500,
          },
          // ".titled-group-header-title-content .MuiSvgIcon-root": {
          //   fontSize: "16px !important",
          // },
        }}
      >
        <Flx column gap={3}>
          {/* <RffFormChanges
            initialValues={loanDrilldown}
            onSubmit={handleOnSubmit}
          >
            <SummaryTabLoanInformationCard />
          </RffFormChanges> */}
          <SummaryTabSummaryCard baseUrl={baseUrl} />
          {/* <Flx gap={3} wrap> */}
          <SummaryTabLoanTotalsCard />
          {/* <SummaryTabLoanSyncDetails /> */}
          {/* </Flx> */}
          <LoanDrilldownChangesForm>
            <Flx gap={3} wrap>
              <SummaryTabLoanInformationCard baseUrl={baseUrl} />
              {/* <SummaryTabTermsCard baseUrl={baseUrl} /> */}
              <SummaryTabLoanAssigneesCard baseUrl={baseUrl} />
            </Flx>
          </LoanDrilldownChangesForm>
          <Flx wrap gap={3}>
            <Flx
              column
              gap={3}
              sx={{ flexBasis: "1020px", flexShink: 0, flexGrow: 1 }}
            >
              <SummaryLoanRelatedContactsCard sx={{ flexGrow: 1 }} />

              <Flx gap={3} wrap>
                <SummaryTabBorrowersCard baseUrl={baseUrl} />
                <SummaryTabPropertiesCard PropertiesCard baseUrl={baseUrl} />
              </Flx>
            </Flx>
            <SummaryTabCommentsCard width="465px" baseUrl={baseUrl} />
          </Flx>

          <SummaryTabLoanFilesCard baseUrl={baseUrl} />
        </Flx>
      </ScreenContent>
    </TabPanel>
  );
};

export default LoanDrilldownSummaryTab;
